import { fromJS } from 'immutable';
import axios from 'axios';
import { BASE_URL } from '../../store/config';
import { roleAnalysis } from '../../common/common'
import instance from '../../request/http'
// init data
const defaultState = fromJS({

});

// action key
// action
export const doLogin = (params, callback) => {
    return (dispath) => {
        //异步action
        axios.post(BASE_URL + 'users/auth/login', params).then((res) => {
            if (res.status === 200) {
                const token = res.data.data.access_token;
                // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJqdGkiOiI2NzBiODMzNC1iNjVjLTQ2ODItYjMyMy0yOThjNDAyNWRhMWIiLCJpYXQiOjE1OTQ3MTkyODIsIm5iZiI6MTU5NDcxOTI4MiwiZXhwIjoxNTk0NzIyODgyLCJ0eXBlIjoiYWNjZXNzIiwiaWRlbnRpdHkiOnsiaWQiOjEsInJvbGUiOlsiYWRtaW4iXX0sImlzcyI6ImJhY2tlbmQifQ.lqoML4K7Us4Fxye4fAwWZGeV__lr8W9frF0ffKbRJoX1BK1vtRny4fSRbx-h_hA3KPyjVaG4XiQaAZZ61XlS1nwjIYM21BSZaSakBhQId3H2rOXnMd5QgDQXIV5ns3R7Vw4Qntf0Ipy_BeVgUiVBslJsEpkp9BAkmRtpngUWRIogrY421csm7YlPr1bUyttdbxduXekeEENaQ8-xsldEvSwWqVqWffCIbaaMEPMLh2mFMEM21ZXsd-fWM_8WHDNPePbK-yYZERUEVpRwozDjr-HXemRbbNqkT3kpcM1-1B0QDKipt5YDZakOHWJ2DLn8A7iKcYKIEJA9ieaAoweu0w";
                const refreshToken = res.data.data.refresh_token;
                localStorage.setItem('token', refreshToken);
                localStorage.setItem('refreshToken', refreshToken);
                instance.defaults.headers.common['Authorization'] = 'Bearer ' + refreshToken;
                roleAnalysis(token);
                callback(true);
            } else {
                callback(false);
            }
        }).catch((err) => {
            callback(false);
        })
    }
};

// reducer
export const reducer = (state = defaultState, action) => {
    return state;
}